import {request} from '@/services';
import type {RequestOptions} from '@/services/request';
import type {
    ChunkInitData,
    ChunkUploadData,
    UploadResult,
    RiskStatusResult,
    UploadSource,
} from '@/types/file';
import type {ProjectId} from '@/types';

const acsToken = true;

const UPLOAD_TIMEOUT = {
    DIRECT: 30_000,
    GET_UPLOAD_ID: 6_000,
    CHUNK_PART: 30_000,
    MERGE: 6_000,
    RISK_STATUS: 6_000,
} as const;

export const directUploadFile = (formData: FormData, options?: RequestOptions) =>
    request.post<UploadResult>('proxy-aicomic/comic/file/upload', formData, {
        timeout: UPLOAD_TIMEOUT.DIRECT,
        ...options,
        acsToken,
    });

export const getUploadId = (
    params: {fileName: string; scene: UploadSource},
    options?: RequestOptions,
) =>
    request.get<ChunkInitData>('proxy-aicomic/comic/file/uploadPart/getUploadId', {
        timeout: UPLOAD_TIMEOUT.GET_UPLOAD_ID,
        ...options,
        params,
        acsToken,
    });

export const uploadChunkPart = (formData: FormData, options?: RequestOptions) =>
    request.post<ChunkUploadData>('proxy-aicomic/comic/file/uploadPart', formData, {
        timeout: UPLOAD_TIMEOUT.CHUNK_PART,
        ...options,
        acsToken,
    });

export const mergeChunkParts = (
    data: {
        uploadId: string;
        key: string;
        total: number;
        etags: string[];
        scene: string;
        fileType: string;
        fileSize: number;
        projectId?: ProjectId;
    },
    options?: RequestOptions,
) =>
    request.post<UploadResult>('proxy-aicomic/comic/file/uploadPart/merge', data, {
        timeout: UPLOAD_TIMEOUT.MERGE,
        ...options,
        acsToken,
    });

export const queryRiskStatus = (params: {taskId: string}, options?: RequestOptions) =>
    request.get<RiskStatusResult>('proxy-aicomic/comic/file/riskStatus', {
        timeout: UPLOAD_TIMEOUT.RISK_STATUS,
        ...options,
        params,
    });
